import React from "react";
import "./ServiceComponents.css";
import EcommerceDashboard from "../assets/images/projectimg/ecommerce-dashboard.jpg";
import Tpclicks from "../assets/images/projectimg/TP CLICKS IMG.jpg";
import Portfolio from "../assets/images/projectimg/portfolio website img .jpg";
import WebPortfolio from "../assets/images/projectimg/WEB DEV PORTFOLIO.jpg";

const WebDevelopment = () => {
  const projects = [
    {
      id: 1,
      title: "E-Commerce Dashboard",
      description: "Frontend of Ecommerce admin dashboard",
      tech: "React, Node.js, MongoDB",
      image: EcommerceDashboard,
      url: "https://talhas-react-ecommerce-dashboard.netlify.app/",
    },
    {
      id: 2,
      title: "Web Developer Portfolio",
      description: "Dynamic portfolio website of a web developer",
      tech: "React, Node.js, Mongo",
      image: WebPortfolio,
      url: "https://mtalhawebportfolio.netlify.app/",
    },
    {
      id: 3,
      title: "Photography Portfolio",
      description: "A Photographer's Portfolio work B&W to colorful",
      tech: "React",
      image: Tpclicks,
      url: "https://tpclicks.netlify.app/",
    },
    {
      id: 4,
      title: "Portfolio Website",
      description: "Creative portfolio for web developer",
      tech: "React",
      image: Portfolio,
      url: "https://talha-second-portfolio.netlify.app/", // Add your actual URL
    },
  ];

  const handleViewProject = (url) => {
    // Open the URL in a new tab
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="service-component">
      <h2 className="service-title">Web Development Projects</h2>
      <p className="service-description">
        Modern, responsive web applications built with cutting-edge technologies
      </p>

      <div className="projects-grid">
        {projects.map((project) => (
          <div key={project.id} className="project-card">
            <div className="project-image">
              {project.image ? (
                <img
                  src={project.image}
                  alt={project.title}
                  className="project-img"
                />
              ) : (
                <div className="image-placeholder">
                  <span className="placeholder-text">{project.title}</span>
                </div>
              )}
            </div>
            <div className="project-content">
              <h3 className="project-title">{project.title}</h3>
              <p className="project-desc">{project.description}</p>
              <div className="project-tech">
                <span className="tech-badge">{project.tech}</span>
              </div>
              <button
                className="project-btn"
                onClick={() => handleViewProject(project.url)}
                disabled={!project.url} // Disable button if no URL
              >
                {project.url ? "View Project" : "Coming Soon"}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WebDevelopment;
